import {Console} from 'console'
import fs from 'fs'

import {
  Document,
  AlignmentType,
  BorderStyle,
  convertInchesToTwip,
  Footer,
  Header,
  ImageRun,
  Packer,
  PageNumber,
  Paragraph,
  Table,
  TableCell,
  TableRow,
  TextRun,
  VerticalAlign,
  WidthType,
  TableWidthElement,
  Alignment,
} from 'docx'
import {saveAs} from 'file-saver'
import {SearchBankAccount} from './AccountSearch'

import React, {useEffect, useState} from 'react'
import {array} from 'yup'
import {memorandum} from '../../../_metronic/assets/ts'

function parseAccountsTable(accounts: SearchBankAccount[]): Table {
  const mainAccount = accounts.find(
    (acc: SearchBankAccount) => acc.type.toLowerCase().trim() === 'g'
  )
  const currentAccount = mainAccount ?? accounts[0]
  const array = [
    currentAccount,
    ...accounts.filter((acc: SearchBankAccount) => acc.accountId !== currentAccount.accountId),
  ]

  const items = array.map((item: any, index: any) => {
    return new TableRow({
      children: [
        new TableCell({
          // margins: {
          //   top: convertInchesToTwip(0.02),
          //   bottom: convertInchesToTwip(0.02),
          //   left: convertInchesToTwip(0.19),
          //   right: convertInchesToTwip(0.19),
          // },
          verticalAlign: VerticalAlign.CENTER,
          children: [
            new Paragraph({
              text:
                item.statusDateTime == null
                  ? ''
                  : item.statusDateTime > item.typeDateTime
                  ? new Date(item.statusDateTime).toLocaleDateString('de-DE', {
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit',
                    })
                  : new Date(item.typeDateTime).toLocaleDateString('de-DE', {
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit',
                    }),
              alignment: AlignmentType.CENTER,
              style: 'table-cell',
              keepNext: index >= array.length - 1,
            }),
          ],
        }),
        new TableCell({
          // margins: {
          //   top: convertInchesToTwip(0.02),
          //   bottom: convertInchesToTwip(0.02),
          //   left: convertInchesToTwip(0.19),
          //   right: convertInchesToTwip(0.19),
          // },
          verticalAlign: VerticalAlign.CENTER,
          children: [
            new Paragraph({
              text: item.bban ?? '',
              alignment: AlignmentType.CENTER,
              style: 'table-cell',
              keepNext: index >= array.length - 1,
            }),
          ],
        }),
        new TableCell({
          // margins: {
          //   top: convertInchesToTwip(0.02),
          //   bottom: convertInchesToTwip(0.02),
          //   left: convertInchesToTwip(0.69),
          //   right: convertInchesToTwip(0.69),
          // },
          verticalAlign: VerticalAlign.CENTER,
          children: [
            new Paragraph({
              text: item.bank ?? '',
              alignment: AlignmentType.CENTER,
              style: 'table-cell',
              keepNext: index >= array.length - 1,
            }),
          ],
        }),
        new TableCell({
          // margins: {
          //   top: convertInchesToTwip(0.02),
          //   bottom: convertInchesToTwip(0.02),
          //   left: convertInchesToTwip(0.19),
          //   right: convertInchesToTwip(0.19),
          // },

          verticalAlign: VerticalAlign.CENTER,
          children: [
            new Paragraph({
              text: item.statusName ?? '',
              alignment: AlignmentType.CENTER,
              style: 'table-cell',
              keepNext: index >= array.length - 1,
            }),
          ],
        }),
        new TableCell({
          // margins: {
          //   top: convertInchesToTwip(0.02),
          //   bottom: convertInchesToTwip(0.02),
          //   left: convertInchesToTwip(0.19),
          //   right: convertInchesToTwip(0.19),
          // },
          verticalAlign: VerticalAlign.CENTER,
          children: [
            new Paragraph({
              text: item.typeName ?? '',
              alignment: AlignmentType.CENTER,
              style: 'table-cell',
              keepNext: index >= array.length - 1,
            }),
          ],
        }),
      ],
    })
  })

  return new Table({
    alignment: AlignmentType.CENTER,
    indent: {
      size: 1666,
      type: WidthType.DXA,
    },
    rows: [
      new TableRow({
        tableHeader: true,
        children: [
          new TableCell({
            margins: {
              top: convertInchesToTwip(0.02),
              bottom: convertInchesToTwip(0.02),
              left: convertInchesToTwip(0.19),
              right: convertInchesToTwip(0.19),
            },
            verticalAlign: VerticalAlign.CENTER,
            shading: {fill: '336799'},
            children: [
              new Paragraph({
                text: 'Datum promjene',
                alignment: AlignmentType.LEFT,
                style: 'table-header',
              }),
            ],
          }),
          new TableCell({
            margins: {
              top: convertInchesToTwip(0.02),
              bottom: convertInchesToTwip(0.02),
              left: convertInchesToTwip(0.39),
              right: convertInchesToTwip(0.39),
            },
            verticalAlign: VerticalAlign.CENTER,
            shading: {fill: '336799'},
            children: [
              new Paragraph({
                text: 'Broj računa',
                alignment: AlignmentType.CENTER,
                style: 'table-header',
              }),
            ],
          }),
          new TableCell({
            margins: {
              top: convertInchesToTwip(0.02),
              bottom: convertInchesToTwip(0.02),
              left: convertInchesToTwip(0.61),
              right: convertInchesToTwip(0.61),
            },
            verticalAlign: VerticalAlign.CENTER,
            shading: {fill: '336799'},
            children: [
              new Paragraph({
                text: 'Banka',
                alignment: AlignmentType.CENTER,
                style: 'table-header',
              }),
            ],
          }),
          new TableCell({
            margins: {
              top: convertInchesToTwip(0.02),
              bottom: convertInchesToTwip(0.02),
              left: convertInchesToTwip(0.19),
              right: convertInchesToTwip(0.19),
            },
            verticalAlign: VerticalAlign.CENTER,
            shading: {fill: '336799'},
            children: [
              new Paragraph({
                text: 'Status računa',
                alignment: AlignmentType.CENTER,
                style: 'table-header',
              }),
            ],
          }),
          new TableCell({
            margins: {
              top: convertInchesToTwip(0.02),
              bottom: convertInchesToTwip(0.02),
              left: convertInchesToTwip(0.19),
              right: convertInchesToTwip(0.19),
            },
            verticalAlign: VerticalAlign.CENTER,
            shading: {fill: '336799'},
            children: [
              new Paragraph({
                text: 'Vrsta računa',
                alignment: AlignmentType.CENTER,
                style: 'table-header',
              }),
            ],
          }),
        ],
      }),
      ...items,
    ],
  })
}
/*class ConvertedSearchBankAccount {
  accountId: number

  accountHolder: boolean

  individualEntityId: string
  individualEntityName: string
  individualEntityLocation: string

  businessEntityId: string
  businessEntityName: string
  businessEntityLocation: string

  bank: string
  bankCode: number
  bic: string
  iban: string
  bban: string
  type: string
  status: string
  statusDateTime: String
  typeDateTime: String
  constructor(item: SearchBankAccount[]) { 
    Object.keys(item[]).forEach
  }

}*/

export default function exportDocx(
  accounts: SearchBankAccount[],
  iba: boolean,
  bba: boolean,
  issuerDocumentId: string,
  requesteeDocumentId: string,
  requesteeFullName: string,
  RequesteeAddress: string,
  legalBasisNote: string,
  documentPurposeNote: string,
  selectedItem: any,
  content: string,
  footerArticle: any,
  uploadChecker: boolean,
  glavni: boolean
) {
  const today = new Date().toLocaleDateString('de-DE', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  })

  const mainAccount = accounts.find(
    (acc: SearchBankAccount) => acc.type.toLowerCase().trim() === 'g'
  )

  const currentAccount = mainAccount ?? accounts[0]
  const array = [
    currentAccount,
    ...accounts.filter((acc: SearchBankAccount) => acc.accountId !== currentAccount.accountId),
  ]
  for (let i = 0; i < array.length; i++) {
    if (array[i].bban == '') {
      array[i].bban =
        'Broj računa za matični broj ' + array[i].individualEntityId + ' nije pronađen u bazi'
    }
  }

  const items = array.map((item: any, index: any) => {
    return new TableRow({
      children: [
        new TableCell({
          // margins: {
          //   top: convertInchesToTwip(0.02),
          //   bottom: convertInchesToTwip(0.02),
          //   left: convertInchesToTwip(0.19),
          //   right: convertInchesToTwip(0.19),
          // },
          verticalAlign: VerticalAlign.CENTER,
          children: [
            new Paragraph({
              text:
                item.statusDateTime > item.typeDateTime
                  ? new Date(item.statusDateTime).toLocaleDateString('de-DE', {
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit',
                    })
                  : new Date(item.typeDateTime).toLocaleDateString('de-DE', {
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit',
                    }),
              alignment: AlignmentType.CENTER,
              style: 'table-cell',
              keepNext: index >= array.length - 1,
            }),
          ],
        }),
        new TableCell({
          // margins: {
          //   top: convertInchesToTwip(0.02),
          //   bottom: convertInchesToTwip(0.02),
          //   left: convertInchesToTwip(0.19),
          //   right: convertInchesToTwip(0.19),
          // },
          verticalAlign: VerticalAlign.CENTER,
          children: [
            new Paragraph({
              text: item.bban ?? '',
              alignment: AlignmentType.CENTER,
              style: 'table-cell',
              keepNext: index >= array.length - 1,
            }),
          ],
        }),
        new TableCell({
          // margins: {
          //   top: convertInchesToTwip(0.02),
          //   bottom: convertInchesToTwip(0.02),
          //   left: convertInchesToTwip(0.69),
          //   right: convertInchesToTwip(0.69),
          // },
          verticalAlign: VerticalAlign.CENTER,
          children: [
            new Paragraph({
              text: item.bank ?? '',
              alignment: AlignmentType.CENTER,
              style: 'table-cell',
              keepNext: index >= array.length - 1,
            }),
          ],
        }),
        new TableCell({
          // margins: {
          //   top: convertInchesToTwip(0.02),
          //   bottom: convertInchesToTwip(0.02),
          //   left: convertInchesToTwip(0.19),
          //   right: convertInchesToTwip(0.19),
          // },

          verticalAlign: VerticalAlign.CENTER,
          children: [
            new Paragraph({
              text: iba ? item.statusName : item.status,
              alignment: AlignmentType.CENTER,
              style: 'table-cell',
              keepNext: index >= array.length - 1,
            }),
          ],
        }),
        new TableCell({
          // margins: {
          //   top: convertInchesToTwip(0.02),
          //   bottom: convertInchesToTwip(0.02),
          //   left: convertInchesToTwip(0.19),
          //   right: convertInchesToTwip(0.19),
          // },
          verticalAlign: VerticalAlign.CENTER,
          children: [
            new Paragraph({
              text: iba
                ? item.typeName
                : item.type != '' && item.type != 'X' && item.type != 'W'
                ? item.type
                : 'Vrsta računa nije određena',
              alignment: AlignmentType.CENTER,
              style: 'table-cell',
              keepNext: index >= array.length - 1,
            }),
          ],
        }),
      ],
    })
  })

  const table = new Table({
    alignment: AlignmentType.CENTER,
    indent: {
      size: 1666,
      type: WidthType.DXA,
    },
    rows: [
      new TableRow({
        tableHeader: true,
        children: [
          new TableCell({
            margins: {
              top: convertInchesToTwip(0.02),
              bottom: convertInchesToTwip(0.02),
              left: convertInchesToTwip(0.19),
              right: convertInchesToTwip(0.19),
            },
            verticalAlign: VerticalAlign.CENTER,
            shading: {fill: '336799'},
            children: [
              new Paragraph({
                text: 'Datum promjene',
                alignment: AlignmentType.CENTER,
                style: 'table-header',
              }),
            ],
          }),
          new TableCell({
            margins: {
              top: convertInchesToTwip(0.02),
              bottom: convertInchesToTwip(0.02),
              left: convertInchesToTwip(0.39),
              right: convertInchesToTwip(0.39),
            },
            verticalAlign: VerticalAlign.CENTER,
            shading: {fill: '336799'},
            children: [
              new Paragraph({
                text: 'Broj računa',
                alignment: AlignmentType.CENTER,
                style: 'table-header',
              }),
            ],
          }),
          new TableCell({
            margins: {
              top: convertInchesToTwip(0.02),
              bottom: convertInchesToTwip(0.02),
              left: convertInchesToTwip(0.61),
              right: convertInchesToTwip(0.61),
            },
            verticalAlign: VerticalAlign.CENTER,
            shading: {fill: '336799'},
            children: [
              new Paragraph({
                text: 'Banka',
                alignment: AlignmentType.CENTER,
                style: 'table-header',
              }),
            ],
          }),
          new TableCell({
            margins: {
              top: convertInchesToTwip(0.02),
              bottom: convertInchesToTwip(0.02),
              left: convertInchesToTwip(0.19),
              right: convertInchesToTwip(0.19),
            },
            verticalAlign: VerticalAlign.CENTER,
            shading: {fill: '336799'},
            children: [
              new Paragraph({
                text: 'Status računa',
                alignment: AlignmentType.CENTER,
                style: 'table-header',
              }),
            ],
          }),
          new TableCell({
            margins: {
              top: convertInchesToTwip(0.02),
              bottom: convertInchesToTwip(0.02),
              left: convertInchesToTwip(0.19),
              right: convertInchesToTwip(0.19),
            },
            verticalAlign: VerticalAlign.CENTER,
            shading: {fill: '336799'},
            children: [
              new Paragraph({
                text: 'Vrsta računa',
                alignment: AlignmentType.CENTER,
                style: 'table-header',
              }),
            ],
          }),
        ],
      }),
      ...items,
    ],
  })

  const mainContent = accounts.length > 0 ? table : new Paragraph('Nema rezultata')
  const text = iba
  const doc = new Document({
    styles: {
      default: {},
      paragraphStyles: [
        {
          id: 'table-header',
          basedOn: 'Normal',
          quickFormat: true,
          run: {
            size: 18,
            font: 'Cambria',
            color: 'ffffff',
          },
        },
        {
          id: 'table-cell',
          basedOn: 'Normal',
          quickFormat: true,
          run: {
            size: 18,
            font: 'Cambria',
          },
        },
        {
          id: 'signature',
          basedOn: 'table-cell',
          quickFormat: true,
          run: {
            size: 22,
            font: 'Cambria',
          },
        },
        {
          id: 'footer',
          basedOn: 'Normal',
          quickFormat: true,
          run: {
            size: 16,
            font: 'Cambria',
            // bold: true
          },
        },
        {
          id: 'normal',
          name: 'Normal1',
          basedOn: 'Normal',
          next: 'Normal',
          quickFormat: true,
          run: {
            size: 22,
            font: 'Cambria',
          },
          paragraph: {
            spacing: {
              after: 120,
            },
          },
        },
        {
          id: 'bold',
          name: 'Bold 2',
          basedOn: 'Normal',
          next: 'Normal',
          quickFormat: true,
          run: {
            size: 22,
            bold: true,
            font: 'Cambria',
          },
          paragraph: {
            spacing: {
              before: 340,
              after: 0,
            },
          },
        },
        {
          id: 'bold-normal',
          name: 'Bold 2',
          basedOn: 'Normal',
          next: 'Normal',
          quickFormat: true,
          run: {
            size: 22,
            bold: true,
            font: 'Cambria',
          },
          paragraph: {
            spacing: {
              after: 0,
            },
          },
        },
        {
          id: 'aside',
          name: 'Aside',
          basedOn: 'Normal',
          next: 'Normal',
          run: {
            color: '999999',
            italics: true,
          },
          paragraph: {
            indent: {
              left: 720,
            },
            spacing: {
              line: 276,
            },
          },
        },
        {
          id: 'wellSpaced',
          name: 'Well Spaced',
          basedOn: 'Normal',
          quickFormat: true,
          paragraph: {
            spacing: {line: 276, before: 20 * 72 * 0.1, after: 20 * 72 * 0.05},
          },
        },
        {
          id: 'ListParagraph',
          name: 'List Paragraph',
          basedOn: 'Normal',
          quickFormat: true,
        },
      ],
    },
    sections: [
      {
        properties: {
          page: {
            margin: {
              top: 800,
              right: 1000,
              // bottom: 0,
              left: 1000,
            },
          },
        },
        headers: {
          default: new Header({
            children: [
              new Paragraph({
                spacing: {
                  after: 200,
                },
                children: [
                  new ImageRun({
                    data: Uint8Array.from(atob(memorandum), (c) => c.charCodeAt(0)),
                    transformation: {
                      width: 259.16,
                      height: 62.32,
                    },
                  }),
                ],
              }),
            ],
          }),
        },

        children: [
          new Paragraph(''),
          new Paragraph({
            text: `Broj: ${issuerDocumentId}`,
            style: 'normal',
          }),
          new Paragraph({
            text: `Sarajevo, ${today} godine`,
            style: 'normal',
          }),
          new Paragraph({
            text: `Podnosilac zahtjeva:`,
            style: 'bold',
          }),
          new Paragraph({
            text: `${requesteeFullName}`,
            style: 'bold-normal',
          }),
          new Paragraph({
            text: `${RequesteeAddress}`,
            style: 'bold-normal',
          }),
          new Paragraph({
            text: ' ',
            style: 'bold',
          }),
          new Paragraph({
            text: 'Podaci o vlasniku računa:',
            style: 'bold',
          }),
          new Paragraph({
            text: `${
              currentAccount.businessEntityName != null
                ? currentAccount.businessEntityName.replace('<![CDATA[&]]>', '&')
                : uploadChecker == true
                ? 'Pretraga vršena za više osoba'
                : currentAccount.individualEntityName
            } `,
            style: 'bold-normal',
          }),
          new Paragraph({
            text: `${
              iba == true && !uploadChecker ? 'JMB: ' : bba == true && !uploadChecker ? 'JIB: ' : ''
            }  ${
              currentAccount.businessEntityId != null
                ? currentAccount.businessEntityId
                : uploadChecker == true
                ? ''
                : currentAccount.individualEntityId
            }`,
            style: 'bold-normal',
          }),
          new Paragraph({
            text: `${
              currentAccount.businessEntityLocation != null
                ? 'Adresa: ' + currentAccount.businessEntityLocation
                : ''
            }`,
            //text: `Adresa: ${currentAccount.businessEntityLocation != null ? currentAccount.businessEntityLocation : currentAccount.individualEntityLocation}`,
            style: 'bold-normal',
          }),
          new Paragraph({
            text: `Poziv na broj: ${requesteeDocumentId}`,
            style: 'bold-normal',
            spacing: {before: 200, after: 100},
          }),
          new Paragraph({
            text:
              bba && !glavni
                ? 'IZVOD O OTVORENIM RAČUNIMA IZ JEDINSTVENOG REGISTRA RAČUNA POSLOVNIH SUBJEKATA FEDERACIJE BiH'
                : bba && glavni
                ? 'IZVOD O GLAVNOM RAČUNU IZ JEDINSTVENOG REGISTRA RAČUNA POSLOVNIH SUBJEKATA FEDERACIJE BIH'
                : 'IZVOD IZ REGISTRA RAČUNA FIZIČKIH LICA',
            //text: `${content}`,
            style: 'bold',
            alignment: AlignmentType.CENTER,
            spacing: {before: 600, after: 400},
            keepLines: true,
            keepNext: true,
          }),
          mainContent,
          new Paragraph({
            children: [new TextRun({text: `${selectedItem.label1}`, bold: true})],
            style: 'signature',
            alignment: AlignmentType.END,
            spacing: {before: selectedItem.verticalSpacing1},
            indent: {right: selectedItem.rightIndentLine1},
            keepLines: true,
            keepNext: true,
            widowControl: true,
          }),
          new Paragraph({
            children: [new TextRun({text: `${selectedItem.label2}`, bold: false})],
            style: 'signature',
            alignment: AlignmentType.END,
            spacing: {before: selectedItem.verticalSpacing2},
            indent: {right: selectedItem.rightIndentLine2},
            keepLines: true,
            keepNext: true,
            widowControl: true,
          }),
          new Paragraph({
            children: [new TextRun({text: `${selectedItem.label3}`, bold: false})],
            style: 'signature',
            spacing: {before: selectedItem.verticalSpacing3},
            indent: {right: selectedItem.rightIndentLine3},
            alignment: AlignmentType.END,
            keepLines: true,
            keepNext: true,
            widowControl: true,
          }),
        ],

        footers: {
          default: new Footer({
            children: [
              // new Paragraph({
              //   children: [
              //     new TextRun({text: 'Status računa: ', bold: true}),
              //     new TextRun({text: 'A - aktivan, B - blokiran, U - ugašen'}),
              //   ],
              //   style: 'footer',
              //   border: {
              //     top: {
              //       color: 'auto',
              //       space: 1,
              //       style: BorderStyle.SINGLE,
              //       size: 6,
              //     },
              //   },
              // }),
              // new Paragraph({
              //   children: [
              //     new TextRun({text: 'Vrsta računa: ', bold: true}),
              //     new TextRun({
              //       text: `${currentAccount != null ? 'G - osnovni račun, T - tekući račun, D - devizni račun, Z - depozitni račun, O - oročeni račun' :
              //       'R - redovni, G - glavni, O - račun organizacionog dijela, P - posebne namjene, J - za prikupljanje javnih prihoda, D - devizni, K - depozit koji predstavlja kolateral, S - račun poslovnog subjekta koji je u stečaju, F -  finansijska konsolidacija'}`,
              //     }),
              //   ],
              //   style: 'footer',
              // }),

              new Paragraph({
                border: {
                  top: {
                    color: 'auto',
                    space: 1,
                    style: BorderStyle.SINGLE,
                    size: 6,
                  },
                },
                alignment: AlignmentType.JUSTIFIED,
                children: [
                  new TextRun({text: `${footerArticle.bold1}`, bold: true}),
                  new TextRun({text: `${footerArticle.text1}`}),
                  /* new TextRun({text:'Napomena: ',bold:true}),
                new TextRun({text:'Korisnici podatke iz Registra mogu koristiti radi obavljanja poslova u okviru zakonom utvrđene nadležnosti isključivo u svrhu za koje su pribavljeni i ne mogu ih dalje saopštavati ili dostavljati trećim licima, niti tim licima omogućiti pristup ovim podacima, osim u slučajevima utvrđenim Zakonom'}),*/
                ],
              }),

              new Paragraph({
                border: {
                  top: {
                    color: 'auto',
                    space: 1,
                    style: BorderStyle.SINGLE,
                    size: 6,
                  },
                },
                alignment: AlignmentType.JUSTIFIED,
                children: [
                  new TextRun({text: `${footerArticle.bold2}`, bold: true}),
                  new TextRun({text: `${footerArticle.text2}`}),
                  /* new TextRun({text:'Napomena: ',bold:true}),
                new TextRun({text:'Korisnici podatke iz Registra mogu koristiti radi obavljanja poslova u okviru zakonom utvrđene nadležnosti isključivo u svrhu za koje su pribavljeni i ne mogu ih dalje saopštavati ili dostavljati trećim licima, niti tim licima omogućiti pristup ovim podacima, osim u slučajevima utvrđenim Zakonom'}),*/
                ],
              }),

              new Paragraph({
                alignment: AlignmentType.RIGHT,
                children: [
                  new TextRun({
                    children: ['str. ', PageNumber.CURRENT, ' od ', PageNumber.TOTAL_PAGES],
                  }),
                ],
              }),
            ],
          }),
        },
      },
    ],
  })

  Packer.toBlob(doc).then((blob) => {
    const fileName = `Izvod - JRR FBiH - ${
      currentAccount.businessEntityId != null
        ? currentAccount.businessEntityId
        : currentAccount.individualEntityId
    } - ${today}`
    saveAs(blob, `${fileName}.docx`)
  })
}
